import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import * as Sentry from '@sentry/browser';

import getStore from './store'
import getRoutes from './routes'

const store = getStore()
const { getState } = store

import { selectIsAuthenticated } from 'common/redux/selectors/auth'
import { setItemOnInitialLoad } from 'common/redux/root'
import { activateSegment } from 'common/analytics'

import { selectIsBLA } from 'broker/selectors/account'

Sentry.init({
  dsn: window.OD.initialState['sentry_dsn'],
  environment: `${window.OD.initialState['env']}-js`,
  maxBreadcrumbs: 20,
  ignoreErrors: [
    "Non-Error promise rejection captured with keys: error",
  ],
  beforeSend(event) {
    if (event.exception && event.exception.values) {
      const exceptionMessage = event.exception.values[0].value;
      if (exceptionMessage && exceptionMessage.includes("Failed to execute 'matches' on 'Element': The provided selector is empty")) {
        return null;
      }
    }
    return event;
  }
});

const analyticsWrapper = () => {
  const envConfig = window.OD.initialState.env_config

  const isAuthenticated = selectIsAuthenticated(getState())

  const sourceKeyId = envConfig.SEGMENT_BROKER_SOURCE_KEY

  if (sourceKeyId && !window.analytics && isAuthenticated) {
    activateSegment(sourceKeyId)
    // dispatches event once segment is initialized
    window.analytics.ready(() => {
      let segmentInitializationAttemptNumber = 0
      const initialSegmentAction = () => {
        segmentInitializationAttemptNumber += 1
        const state = getState()
        const { account } = state
        if (!_.isEmpty(account) && _.has(account, 'is_partner_brokerage')) {
          const isBLA = selectIsBLA(getState())

          store.dispatch(
            setItemOnInitialLoad({
              traits: { 'is_bla': isBLA }
            })
          )
        } else if (segmentInitializationAttemptNumber < 20) {
          setTimeout(initialSegmentAction, 500)
        } else {
          store.dispatch(
            setItemOnInitialLoad({})
          )
        }
      }

      initialSegmentAction()
    })
  } else if (sourceKeyId && !window.analytics) {
    activateSegment(sourceKeyId)
  }
}

analyticsWrapper()

render((<Provider store={store}>{ getRoutes(store) }</Provider>), document.getElementById('main'))
